export enum AddOrRemoveProfileTypeEnum {
  BlueProfile = 0,
  GreyProfile = 1,
  DarkProfile = 2
}
